export default __webpack_public_path__ + "static/media/lock_icon.6c29620c.svg";